import { PresetColorTypes } from '../_util/colors'; // eslint-disable-next-line import/prefer-default-export

export function isPresetColor(color) {
  return PresetColorTypes.indexOf(color) !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components-antd-x4/es/badge/utils.js
// module id = 778
// module chunks = 0